var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BBadge',{staticClass:"'badge-light bg-white border my-auto mr-2",class:_vm.styling[_vm.tenantTier],attrs:{"data-testid":"tenant-tier-badge"}},[_vm._v(" "+_vm._s(_vm.$t(("tenantTierAbbreviation." + _vm.tenantTier)))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }